import { ImageScaleView, View, ViewOpts } from '@play-co/timestep-core/ui';
import StateObserver from 'src/StateObserver';
import gsap from 'gsap';

export class CardsCongratulations extends View {
  private album: ImageScaleView;
  private message: ImageScaleView;

  constructor(opts?: ViewOpts) {
    super({
      ...opts,
      width: 631,
      height: 105,
    });

    this.album = new ImageScaleView({
      superview: this,
      x: this.style.width / 2,
      y: this.style.height / 2 - 70,
      width: 233,
      height: 166,
      centerOnOrigin: true,
      image: 'assets/ui/cards/common/album.png',
      scale: 0,
    });

    const locale = StateObserver.getLocale();

    this.message = new ImageScaleView({
      superview: this,
      image: `assets/ui/cards/common/congratulations_${locale}.png`,
      x: this.style.width / 2,
      y: this.style.height / 2,
      width: 631,
      height: 105,
      centerOnOrigin: true,
      scale: 0,
    });
  }

  public async showAnimated() {
    await gsap.to(this.message.style, {
      scale: 1,
      duration: 0.3,
      ease: 'back.out',
    });
    await gsap.to(this.album.style, {
      scale: 1,
      duration: 0.3,
      ease: 'back.out',
    });
  }
}
